import React from 'react';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import { useFormikContext } from 'formik';
import { DEFAULT_BLUR_TIMEOUT } from 'components/PriceUnitField/components/FormInputWithPrecisionDisplay';

interface Props {
  cancelText?: string;
  cancelIcon?: React.ReactNode;
  submitText?: string;
  submitIcon?: React.ReactNode;
  isSubmitDisabled?: boolean;
  onClose: () => void;
  className?: string;
}

const FormDrawerFooter: React.FC<Props> = ({
  submitText = 'Save',
  submitIcon,
  cancelText = 'Cancel',
  cancelIcon,
  isSubmitDisabled,
  onClose,
  className = 'flex justify-between'
}) => {
  const {
    initialValues,
    isValid,
    isSubmitting,
    dirty,
    submitForm,
    resetForm
  } = useFormikContext();

  return (
    <div className={className}>
      <Button
        data-testid="cancel-button"
        type={ButtonType.outline}
        onClick={() => {
          resetForm({ values: initialValues });
          if (onClose) onClose();
        }}
        size="large"
        icon={cancelIcon}
      >
        {cancelText}
      </Button>
      <Button
        data-testid="save-button"
        disabled={!isValid || !dirty || isSubmitDisabled}
        type={ButtonType.primary}
        onClick={() => {
          // scenario: user hit save with a focused input
          // we are using FormInputWithPrecisionDisplay component that uses onblur and focus events to update the value and display value
          // so we need to use setTimeout to make sure the formik submit is called at the end of the event loop
          // this is not the best solution, but it works, it's a known issue also in yield, need to be discussed and fixed
          (document.activeElement as HTMLElement)?.blur(); // focus the button to trigger blur on any focused input
          setTimeout(submitForm, DEFAULT_BLUR_TIMEOUT);
        }}
        loading={isSubmitting}
        icon={submitIcon}
        size="large"
      >
        {submitText}
      </Button>
    </div>
  );
};

export default FormDrawerFooter;
